import type { SVGProps } from "react";

type IconProps = SVGProps<SVGSVGElement>;

function base(props: IconProps): IconProps {
  return {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    "aria-hidden": true,
    ...props,
  };
}

export function CheckIcon(props: IconProps) {
  return (
    <svg {...base(props)} strokeWidth={2.5}>
      <path d="m5 12.5 4.5 4.5L19 7.5" />
    </svg>
  );
}

export function CalendarIcon(props: IconProps) {
  return (
    <svg {...base(props)}>
      <rect x="3.5" y="5" width="17" height="15.5" rx="2.5" />
      <path d="M3.5 10h17M8 3v4M16 3v4" />
    </svg>
  );
}

export function MoonIcon(props: IconProps) {
  return (
    <svg {...base(props)}>
      <path d="M20 14.5A8 8 0 0 1 9.5 4a8 8 0 1 0 10.5 10.5Z" />
    </svg>
  );
}

export function BoltIcon(props: IconProps) {
  return (
    <svg {...base(props)}>
      <path d="M13 2 3 14h8l-1 8 10-12h-8l1-8z" />
    </svg>
  );
}

export function UsersIcon(props: IconProps) {
  return (
    <svg {...base(props)}>
      <circle cx="9" cy="8" r="3.5" />
      <path d="M2.5 20a6.5 6.5 0 0 1 13 0M16 4.5a3.5 3.5 0 0 1 0 7M21.5 20a6.5 6.5 0 0 0-4.5-6.2" />
    </svg>
  );
}

export function PinIcon(props: IconProps) {
  return (
    <svg {...base(props)}>
      <path d="M12 21s6.5-5.4 6.5-11A6.5 6.5 0 0 0 5.5 10c0 5.6 6.5 11 6.5 11Z" />
      <circle cx="12" cy="10" r="2.5" />
    </svg>
  );
}

export function InfoIcon(props: IconProps) {
  return (
    <svg {...base(props)}>
      <circle cx="12" cy="12" r="9" />
      <path d="M12 11v5M12 8h.01" />
    </svg>
  );
}

export function AlertIcon(props: IconProps) {
  return (
    <svg {...base(props)}>
      <path d="M12 4 2.75 20h18.5L12 4Z" />
      <path d="M12 10v4M12 17h.01" />
    </svg>
  );
}

export function ClockIcon(props: IconProps) {
  return (
    <svg {...base(props)}>
      <circle cx="12" cy="12" r="9" />
      <path d="M12 7v5l3 2" />
    </svg>
  );
}

export function PencilIcon(props: IconProps) {
  return (
    <svg {...base(props)}>
      <path d="M4 20h4l10.5-10.5a2.1 2.1 0 0 0-3-3L5 17v3Z" />
      <path d="m13.5 6.5 3 3" />
    </svg>
  );
}

export function SparkleIcon(props: IconProps) {
  return (
    <svg {...base(props)}>
      <path d="M12 3v4M12 17v4M3 12h4M17 12h4M6 6l2.5 2.5M15.5 15.5 18 18M6 18l2.5-2.5M15.5 8.5 18 6" />
    </svg>
  );
}

export function MessageIcon(props: IconProps) {
  return (
    <svg {...base(props)}>
      <path d="M4 5.5h16v10H9l-4.5 3.5v-3.5H4v-10Z" />
    </svg>
  );
}

export function MotorhomeIcon(props: IconProps) {
  return (
    <svg {...base(props)}>
      <path d="M3 16.5V8.5a2 2 0 0 1 2-2h8.5l4.5 4v6" />
      <path d="M3 16.5h2M9 16.5h6M19 16.5h2M13.5 6.5v4H18" />
      <circle cx="7" cy="17" r="2" />
      <circle cx="17" cy="17" r="2" />
      <path d="M6 10h4" />
    </svg>
  );
}

export function CaravanIcon(props: IconProps) {
  return (
    <svg {...base(props)}>
      <path d="M3 16V9a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v7" />
      <path d="M17 16h4M3 16h2M9 16h6" />
      <circle cx="7" cy="16.5" r="2" />
      <path d="M6.5 9.5h4v3h-4z" />
    </svg>
  );
}

export function TentIcon(props: IconProps) {
  return (
    <svg {...base(props)}>
      <path d="M2.5 19.5 12 5l9.5 14.5h-19Z" />
      <path d="m12 19.5-3-6-3 6M12 13.5l3 6" />
    </svg>
  );
}

export function TentCarIcon(props: IconProps) {
  return (
    <svg {...base(props)}>
      <path d="M2 19.5 8 9l6 10.5H2Z" />
      <path d="m8 19.5-2-4" />
      <path d="M13.5 15h7a1.5 1.5 0 0 0 1.5-1.5v-1.2l-1.6-2.8a1.5 1.5 0 0 0-1.3-.75H16l-1.8 2.6" />
      <circle cx="19.5" cy="16" r="1.5" />
    </svg>
  );
}

export function TentBikeIcon(props: IconProps) {
  return (
    <svg {...base(props)}>
      <path d="M2 19.5 8 9l6 10.5H2Z" />
      <path d="m8 19.5-2-4" />
      <circle cx="16" cy="17" r="2.5" />
      <circle cx="21" cy="17" r="2" strokeWidth={1.5} />
      <path d="m16 17 2-4.5h3M16 12.5h3" />
    </svg>
  );
}

export function CarIcon(props: IconProps) {
  return (
    <svg {...base(props)}>
      <path d="M4 13.5 5.8 8.6A2 2 0 0 1 7.7 7.3h8.6a2 2 0 0 1 1.9 1.3l1.8 4.9" />
      <path d="M3 13.5h18v3.5a1 1 0 0 1-1 1h-1.5M3 13.5V17a1 1 0 0 0 1 1h1.5M9 18h6" />
      <circle cx="7" cy="17.5" r="1.75" />
      <circle cx="17" cy="17.5" r="1.75" />
    </svg>
  );
}

export function VanIcon(props: IconProps) {
  return (
    <svg {...base(props)}>
      <path d="M3 16V9.5A2.5 2.5 0 0 1 5.5 7H14l5 4.5V16" />
      <path d="M3 16h2.5M9.5 16h5M19.5 16H21M14 7v4.5h5M3 11.5h11" />
      <circle cx="7" cy="16.5" r="2" />
      <circle cx="17" cy="16.5" r="2" />
    </svg>
  );
}

export function VehicleTypeIcon({ code, ...props }: IconProps & { code: string }) {
  const key = code.toLowerCase();
  if (key.includes("tent_car") || key.includes("zelt_auto")) return <TentCarIcon {...props} />;
  if (key.includes("tent_bike") || key.includes("bike") || key.includes("rad")) {
    return <TentBikeIcon {...props} />;
  }
  if (key.includes("tent") || key.includes("zelt")) return <TentIcon {...props} />;
  if (key.includes("caravan") || key.includes("wohnwagen") || key.includes("trailer")) {
    return <CaravanIcon {...props} />;
  }
  if (key.includes("tow") || key.includes("zug") || key.includes("car") || key.includes("pkw")) {
    return <CarIcon {...props} />;
  }
  if (key.includes("van") || key.includes("bus") || key.includes("camper")) {
    return <VanIcon {...props} />;
  }
  return <MotorhomeIcon {...props} />;
}
